export const CURRENT_USER_PREFERENCES = {

  //settings
  exifDownloadsEnabled: 'exifDownloadsEnabled',
  exifDownloadsPrompt: 'exifDownloadsPrompt',
  marsLandingPath: 'landing_path',
  videoDeleteOriginal: 'video_delete_original',
  digitizationAutoTransfer: 'digi_auto_transfer',

  //onboarding states
  onbPeopleDismissed: 'onb_people_dismissed',
  onbDeclutterDismissed: 'onb_declutter_dismissed',
  onbVideoMergeDismissed: 'onb_video_merge_dismissed',
  onbVideoEditDismissed: 'onb_video_edit_dismissed',
  onbVideoTitleFrameDismissed: 'onb_video_title_frame_dismissed'
};
